import { createRouter, createWebHistory } from 'vue-router';
import SurveysView from '@/views/SurveysView.vue';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			name: 'home',
			component: SurveysView,
		},
	],
});

export default router;
